import { t } from 'i18next';
import { Monitor, Settings, SunMoon } from 'lucide-react';

import SidebarLayout, { SidebarItem } from '@/app/components/sidebar-layout';
import { platformHooks } from '@/hooks/platform-hooks';
import { isNil } from '@activepieces/shared';

import { authenticationSession } from '../../lib/authentication-session';
import { redirectToSignIn } from '@/lib/auth-navigation';

const iconSize = 20;

interface SettingsLayoutProps {
  children: React.ReactNode;
}

export default function ProjectSettingsLayout({
  children,
}: SettingsLayoutProps) {
  const { platform } = platformHooks.useCurrentPlatform();
  const currentProjectId = authenticationSession.getProjectId();
  if (isNil(currentProjectId)) {
    redirectToSignIn();
    return null;
  }
  const sidebarNavItems: SidebarItem[] = [
    {
      title: t('General'),
      href: authenticationSession.appendProjectRoutePrefix('/settings/general'),
      icon: <Settings size={iconSize} />,
    },
    {
      title: t('Appearance'),
      href: authenticationSession.appendProjectRoutePrefix(
        '/settings/appearance',
      ),
      icon: <SunMoon size={iconSize} />,
    },
    {
      title: t('Sessions'),
      href: authenticationSession.appendProjectRoutePrefix(
        '/settings/sessions',
      ),
      icon: <Monitor size={iconSize} />,
    },
  ];

  const filterAlerts = (item: SidebarItem) =>
    platform.alertsEnabled || item.title !== t('Alerts');
  const filterOnPermission = (item: SidebarItem) =>
    isNil(item.hasPermission) || item.hasPermission;

  const filteredNavItems = sidebarNavItems
    .filter(filterAlerts)
    .filter(filterOnPermission);

  return (
    <SidebarLayout title={t('Settings')} items={filteredNavItems}>
      {children}
    </SidebarLayout>
  );
}
